import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import pop from "../../../src/images/pop.jpg";

import { toast } from "react-toastify";

const LoginModal = ({ loginModal, setLoginModal }) => {

    const [formData, setFormData] = useState({
        email: '',
        city: '',
        travelerType: '',
    });

    const [errors, setErrors] = useState({
        email: '',
        city: '',
        travelerType: '',
    });
    const [loading, setLoading] = useState(false);

    const cityCodes = {
        'Honolulu': 'HNL',
        'Charlotte': 'CLT',
        'New York City': 'NYC',
        'Las Vegas': 'LAS',
        'Orlando': 'MCO',
        'Los Angeles': 'LAX',
        'San Francisco': 'SFO',
        'Miami': 'MIA',
        'Washington, D.C.': 'WAS',
        'Chicago': 'CHI',
        'Boston': 'BOS',
        'Seattle': 'SEA',
        'Atlanta': 'ATL',
        'San Diego': 'SAN',
        'Houston': 'IAH',
        'Dallas': 'DFW',
        'New Orleans': 'MSY',
        'Denver': 'DEN',
        'Phoenix': 'PHX',
        'Philadelphia': 'PHL',
        'Austin': 'AUS',
        'Nashville': 'BNA',
        'Tampa': 'TPA',
        'Portland': 'PDX',
        'Salt Lake City': 'SLC',
        'San Antonio': 'SAT',
        'Minneapolis': 'MSP',
        'St. Louis': 'STL',
        'Charleston': 'CHS',
        'Savannah': 'SAV'
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };


    const validateForm = () => {
        const newErrors = {
            email: '',
            city: '',
            travelerType: '',
        };
        let isValid = true;

        // Improved email validation regex
        const emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!formData.email) {
            newErrors.email = 'Email is required!';
            isValid = false;
        } else if (!formData.email.includes('@')) {
            newErrors.email = 'Email must contain @!';
            isValid = false;
        } else if (formData.email.startsWith('@') || formData.email.endsWith('@')) {
            newErrors.email = 'Email cannot start or end with @!';
            isValid = false;
        } else if (formData.email.includes('..')) {
            newErrors.email = 'Email cannot contain consecutive dots!';
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address!';
            isValid = false;
        }

        // City validation
        if (!formData.city) {
            newErrors.city = 'City is required!';
            isValid = false;
        }

        // Traveler Type validation
        if (!formData.travelerType) {
            newErrors.travelerType = 'Traveler type is required!';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true); // Start loading

        const { email, city, travelerType } = formData;

        const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(email.split('@')[0])}&city=${encodeURIComponent(city)}&travelerType=${encodeURIComponent(travelerType)}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
            });

            if (response.ok) {
                const data = await response.json();
                //   toast.success(data.message);
                toast.success("Subscriber added successfully!");
                setFormData({ email: '', city: '', travelerType: '' });
                setLoginModal(false);
            } else {
                toast.error("Failed to submit form");
            }
        } catch (error) {
            toast.error(error.message || 'Failed to submit form');
        } finally {
            setLoading(false); // Stop loading
        }
    };


    return (
        <Modal className='model_width_form formslide'
            show={loginModal}
            onHide={() => setLoginModal(false)}
            keyboard={false}
        >
            <Modal.Header closeButton>

            </Modal.Header>

            <Modal.Body className=" slider-modal-dialog" >
                <div className="modal-body slide-form-body">
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1"></button>

                                </div>
                                <div className="carousel-inner slider-form">
                                    <div className="carousel-item active" data-bs-interval={20000}>
                                        <img loading="lazy" src={pop} className="d-block w-100" alt="Slide 1" />
                                        <div className="sliderItembackdrop"></div>
                                        <div className="contant_box_slider">
                                            <div className="carousel-caption">
                                                <h5>Same room, Same flight&mdash;Pay less with MySittiVacations, Plan Smarter!</h5>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="slide_form_sec">
                                <h4>Get Your Free  E-Book: <span>Travel Tips, Inspiration & Hacks!</span></h4>


                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Enter your Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.email && <div className="text-red re_text">{errors.email}</div>}

                                    <select
                                        name="city"
                                        className="form-select"
                                        value={formData.city}
                                        onChange={handleChange}
                                        aria-label="Enter your City"
                                        required
                                    >
                                        <option value="">Enter your City</option>
                                        {Object.keys(cityCodes).map((cityName) => (
                                            <option key={cityName} value={cityName}>
                                                {cityName.replace(/-/g, ' ')}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.city && <div className="text-red re_text">{errors.city}</div>}

                                    <select
                                        name="travelerType"
                                        className="form-select"
                                        value={formData.travelerType}
                                        onChange={handleChange}
                                        aria-label="Enter your Category"
                                        required
                                    >
                                        <option value="">Select Category</option>
                                        <option value="LGBTQ">LGBTQ</option>
                                        <option value="Solo Female">Solo Female</option>
                                        <option value="General">General</option>
                                        <option value="Family">Family</option>
                                        <option value="Couple">Couple</option>
                                    </select>
                                    {errors.travelerType && <div className="text-red re_text">{errors.travelerType}</div>}

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default LoginModal;
